var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import { Dependencies } from "~/core/decorator";
import { Prop, Emit, Watch } from "vue-property-decorator";
import DataBox from "~/components/common/data-box.vue";
import { UserService } from "~/services/management-service/user.service";
import { PageService } from "~/utils/page.service";
var UserSelect = /** @class */ (function (_super) {
    __extends(UserSelect, _super);
    function UserSelect() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.dataSet = [];
        _this.selectionRow = {};
        return _this;
    }
    UserSelect.prototype.emitSuccess = function (val) { };
    UserSelect.prototype.onDepartmentIdChange = function (val) {
        if (val)
            this.getUsers();
    };
    UserSelect.prototype.getUsers = function () {
        var _this = this;
        this.userService.getAllUsers({ deptId: this.departmentId, caseSwitch: 'ENABLED' }, this.pageService).subscribe(function (data) { return _this.dataSet = data; });
    };
    UserSelect.prototype.confirm = function () {
        if (!this.selectionRow.id) {
            this.$message("请选择用户");
            return;
        }
        this.emitSuccess({
            id: this.selectionRow.id,
            realName: this.selectionRow.realName
        });
    };
    __decorate([
        Dependencies(UserService)
    ], UserSelect.prototype, "userService", void 0);
    __decorate([
        Dependencies(PageService)
    ], UserSelect.prototype, "pageService", void 0);
    __decorate([
        Prop({ required: true })
    ], UserSelect.prototype, "departmentId", void 0);
    __decorate([
        Emit("success")
    ], UserSelect.prototype, "emitSuccess", null);
    __decorate([
        Watch("departmentId", { immediate: true })
    ], UserSelect.prototype, "onDepartmentIdChange", null);
    UserSelect = __decorate([
        Component({
            components: {
                DataBox: DataBox
            }
        })
    ], UserSelect);
    return UserSelect;
}(Vue));
export default UserSelect;
